var _defs, _title, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g, _path19;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSignUpContentPlaceholder = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "master-artboard",
    viewBox: "0 0 1400 980",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 1400 980"
    },
    width: "1400px",
    height: "980px",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "266ddccd-2bf2-4e28-b2e5-5ae966d4800f",
    x1: 219.02,
    y1: 323.78,
    x2: 219.02,
    y2: 74.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "626d076d-6f89-411f-83f5-9b8674077322",
    x1: 33.88,
    y1: 206.96,
    x2: 182.23,
    y2: 206.96,
    xlinkHref: "#266ddccd-2bf2-4e28-b2e5-5ae966d4800f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e2ac2573-f441-4fda-b2ca-fa87ebeba1c3",
    x1: 749.04,
    y1: 221.83,
    x2: 749.04,
    y2: 112.64,
    xlinkHref: "#266ddccd-2bf2-4e28-b2e5-5ae966d4800f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bb3d1d29-a72a-47e9-9ad6-cff955e05eb4",
    x1: 628.36,
    y1: 671.95,
    x2: 628.36,
    y2: 527.93,
    xlinkHref: "#266ddccd-2bf2-4e28-b2e5-5ae966d4800f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "69187472-cad7-4cbf-a29f-e953f1d019d9",
    x1: 499.83,
    y1: 650.24,
    x2: 499.83,
    y2: 549.64,
    xlinkHref: "#266ddccd-2bf2-4e28-b2e5-5ae966d4800f"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3424657534246576, 0, 0, 1.3424657534246576, 91.1716382174908, -0.000004682300186686916)"
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "setup")), /*#__PURE__*/React.createElement("path", {
    d: "M 786.149994 365 A 363 363 0 0 1 423.149994 728 A 363 363 0 0 1 60.149994 365 A 363 363 0 0 1 423.149994 2 A 363 363 0 0 1 786.149994 365 Z",
    fill: "none",
    stroke: "#64ffda",
    strokeMiterlimit: 10,
    strokeWidth: 4,
    strokeDasharray: "12.07 15.09",
    style: {
      stroke: "rgb(38, 50, 56)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 76.239998 109.889999 H 458.220009 V 352.860001 H 76.239998 V 109.889999 Z",
    fill: "#ff5722",
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 0 74.959999 H 438.049988 V 323.769997 H 0 V 74.959999 Z",
    fill: "url(#266ddccd-2bf2-4e28-b2e5-5ae966d4800f)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 4.67 111.18 H 432.210009 V 317.939995 H 4.67 V 111.18 Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 33.880001 128.699997 H 182.230007 V 285.229996 H 33.880001 V 128.699997 Z",
    fill: "url(#626d076d-6f89-411f-83f5-9b8674077322)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 38.549999 132.199997 H 178.729992 V 281.720001 H 38.549999 V 132.199997 Z",
    fill: "#ff5722"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M294.27,276.24c-1.1-8.88-2.61-17.81-6-26.09s-8.86-15.94-16.46-20.66a18.81,18.81,0,0,0-9.1-3.15c-6-.21-11.45,3.8-14.52,8.91a41.57,41.57,0,0,0-2.71,5.51,12.83,12.83,0,0,0-10.65,11.75,32.72,32.72,0,0,0,4.63,61.78v5.58a32.84,32.84,0,0,0-24.53,31.67v15.19h65.42V351.54a32.84,32.84,0,0,0-24.53-31.67v-5.58a32.72,32.72,0,0,0,24.53-31.68c0-.08,0-.15,0-.23l3.68,8.19c3.5,7.8,7.09,16.18,5.73,24.62C296.46,303.71,295.9,289.46,294.27,276.24Z",
    transform: "translate(-146.48 -85)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 4.67 79.639999 H 432.210009 V 111.18 H 4.67 V 79.639999 Z",
    fill: "#ff5722"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 235.960007 176.009995 H 398.330002 V 186.519995 H 235.960007 V 176.009995 Z",
    fill: "#e0e0e0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 235.960007 220.399994 H 398.330002 V 230.909994 H 235.960007 V 220.399994 Z",
    fill: "#f5f5f5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M 234.789993 198.199997 H 330.579994 V 208.709997 H 234.789993 V 198.199997 Z",
    fill: "#ff5722",
    opacity: 0.2
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M 667.359985 136.669998 H 882.909988 V 237.189995 H 667.359985 V 136.669998 Z",
    fill: "#ff6e40",
    opacity: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 633.469971 112.639999 H 864.60997 V 221.830002 H 633.469971 V 112.639999 Z",
    fill: "url(#e2ac2573-f441-4fda-b2ca-fa87ebeba1c3)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 641.969971 115.239998 H 857.519974 V 215.759995 H 641.969971 V 115.239998 Z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 674.630005 137.220001 H 800.370003 V 149.150002 H 674.630005 V 137.220001 Z",
    fill: "#ff6e40",
    opacity: 0.3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 674.630005 164.520004 H 739.840004 V 176.450005 H 674.630005 V 164.520004 Z",
    fill: "#ff6e40"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 404.200012 557.440002 H 907.029999 V 692.690002 H 404.200012 V 557.440002 Z",
    fill: "#ff5722",
    opacity: 0.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 373.290009 527.929993 H 883.440002 V 671.939987 H 373.290009 V 527.929993 Z",
    fill: "url(#bb3d1d29-a72a-47e9-9ad6-cff955e05eb4)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M 376.950012 532.809998 H 879.779999 V 667.059998 H 376.950012 V 532.809998 Z",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M 550.129986 599.940002 A 50.299999 50.299999 0 0 1 499.829987 650.240002 A 50.299999 50.299999 0 0 1 449.529987 599.940002 A 50.299999 50.299999 0 0 1 499.829987 549.640003 A 50.299999 50.299999 0 0 1 550.129986 599.940002 Z",
    fill: "url(#69187472-cad7-4cbf-a29f-e953f1d019d9)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M 544.539986 599.940002 A 44.709999 44.709999 0 0 1 499.829987 644.650002 A 44.709999 44.709999 0 0 1 455.119987 599.940002 A 44.709999 44.709999 0 0 1 499.829987 555.230003 A 44.709999 44.709999 0 0 1 544.539986 599.940002 Z",
    fill: "#ff5722"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 587.849976 566.409973 H 667.489975 V 580.379973 H 587.849976 V 566.409973 Z",
    fill: "#ff5722"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 587.849976 592.950012 H 807.199982 V 606.920012 H 587.849976 V 592.950012 Z",
    fill: "#ff5722"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 587.849976 619.5 H 807.199982 V 633.47 H 587.849976 V 619.5 Z",
    fill: "#ff5722"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M 529.1699829101562 582.010009765625 L 519.3499755859375 574.52001953125 L 493.4700012207031 608.4299926757812 L 479.0299987792969 597.4099731445312 L 471.5400085449219 607.219970703125 L 490.8999938964844 622 L 490.95001220703125 621.9299926757812 L 495.8500061035156 625.6699829101562 L 529.1699829101562 582.010009765625 Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M 311.890015 242.589996 H 377.310013 V 253.099997 H 311.890015 V 242.589996 Z",
    fill: "#69f0ae",
    style: {
      fill: "rgb(38, 50, 56)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 234.789993 242.589996 H 300.209991 V 253.099997 H 234.789993 V 242.589996 Z",
    fill: "#69f0ae",
    opacity: 0.2,
    style: {
      fill: "rgb(183, 183, 183)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "rgb(183, 183, 183)",
      fillOpacity: 1,
      stroke: "rgb(0, 0, 0)",
      strokeOpacity: 1,
      strokeWidth: 0,
      paintOrder: "fill"
    },
    d: "M 220.74111938476562 427.630615234375 L 203.369140625 348.99951171875"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSignUpContentPlaceholder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sign-up-content-placeholder.60210565b717a28e2a67c7309097cb76.svg";